buildGeoRestrictions